import HttpRequest from './HttpRequest';

export const getUpcomingConcerts = async () => {
  try {
    const response = await HttpRequest.get('/performances/upcoming');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getPastConcerts = async () => {
  try {
    const response = await HttpRequest.get('/performances/past');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
